// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateShippingMethod_cancelButton__2ULKh"};